// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"532d50bc","384":"30425e75","787":"9fa620c5","998":"5d5912da"}[chunkId] + ".chunk.js";
};